import Contact from './components/Contact.vue';
import Main from './components/Main.vue';
import Club from './components/Club.vue';
import About from './components/About.vue';
import News from './components/News.vue';
import Booking from './components/Booking.vue';
import Field from './components/Field.vue';
import News_subpage from './components/News_page.vue';
import NotFound from './components/404.vue';
import Success from './components/Success.vue';
//import All_products from './components/All_products.vue';
//import Products from './components/Products.vue';
//import Products_subpage from './components/Products_page.vue';

export const routes = [
	{ path: '/', component: Main },
	{ path: '/about', component: About, alias: '/rolunk' },
	{ path: '/contact', component: Contact, alias: '/kapcsolat' },
	{ path: '/booking', component: Booking, alias: '/palyafoglalas' },
	{ path: '/association', component: Club, alias: '/egyesulet' },
	{ path: '/news', component: News, alias: '/hirek'},
	{ path: '/archery-range', component: Field, alias: '/ijaszpalya' },
	{ path: '/hirek/:id/:cikk', component: News_subpage },
	{ path: '/news/:id/:article', component: News_subpage },
	{ path: '/booking-success', component: Success, alias: '/sikeres-foglalas' },
	{ path: '*', component: NotFound }

	/*{ path: '/products', component: All_products },
	{ path: '/termekeink', component: All_products },
	
	{ path: '/products/:type', component: Products, alias: '/products/bows/:type' },
	{ path: '/termekeink/:type', component: Products, alias: '/termekeink/ijak/:type' },
	
	{ path: '/products/:type/:item', component: Products_subpage, alias: '/products/bows/:type/:item' },
	{ path: '/termekeink/:type/:item', component: Products_subpage, alias: '/termekeink/ijak/:type/:item' }*/
	
];


// WEBPACK FOOTER //
// ./src/routes.js